{
  "CANNED_MGMT": {
    "HEADER": "Έτοιμες Απαντήσεις",
    "LEARN_MORE": "Learn more about canned responses",
    "DESCRIPTION": "Canned Responses are pre-written reply templates that help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a canned response during a conversation. ",
    "HEADER_BTN_TXT": "Add canned response",
    "LOADING": "Fetching canned responses...",
    "SEARCH_404": "Δεν υπάρχουν δεδομένα που να ταιριάζουν με αυτό το ερώτημα.",
    "LIST": {
      "404": "Δεν υπάρχουν τυποποιημένες απαντήσεις σε αυτόν τον λογαριασμό.",
      "TITLE": "Διαχείριση έτοιμων απαντήσεων",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "TABLE_HEADER": {
        "SHORT_CODE": "Short code",
        "CONTENT": "ΠΕΡΙΕΧΟΜΕΝΟ",
        "INBOXES": "Εισερχόμενα",
        "ACTIONS": "Ενέργειες"
      },
      "ALL_INBOXES": "Όλα τα εισερχόμενα",
      "FILTER": {
        "ALL_INBOXES": "Όλα τα εισερχόμενα",
        "NO_INBOX": "Χωρίς εισερχόμενα",
        "SEARCH_PLACEHOLDER": "Αναζήτηση εισερχομένων"
      }
    },
    "ADD": {
      "TITLE": "Add canned response",
      "DESC": "Canned Responses are predefined reply templates which can be used to quickly send out replies to conversations.",
      "CANCEL_BUTTON_TEXT": "Άκυρο",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a short code.",
          "ERROR": "Short Code is required."
        },
        "SUBJECT": {
          "LABEL": "Θέμα (μόνο email)",
          "PLACEHOLDER": "Προαιρετικό θέμα για απαντήσεις email / νέες συνομιλίες"
        },
        "CONTENT": {
          "LABEL": "Μήνυμα",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Message is required."
        },
        "ATTACHMENTS": {
          "LABEL": "Συνημμένα"
        },
        "INBOXES": {
          "LABEL": "Εισερχόμενα",
          "PLACEHOLDER": "Επιλέξτε εισερχόμενα (προαιρετικό, αφήστε κενό για όλα τα εισερχόμενα)"
        },
        "SUBMIT": "Καταχώρηση"
      },
      "API": {
        "SUCCESS_MESSAGE": "Canned response added successfully.",
        "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
      }
    },
    "EDIT": {
      "TITLE": "Edit canned response",
      "CANCEL_BUTTON_TEXT": "Άκυρο",
      "FORM": {
        "SHORT_CODE": {
          "LABEL": "Short code",
          "PLACEHOLDER": "Please enter a shortcode.",
          "ERROR": "Short code is required."
        },
        "SUBJECT": {
          "LABEL": "Θέμα (μόνο email)",
          "PLACEHOLDER": "Προαιρετικό θέμα για απαντήσεις email / νέες συνομιλίες"
        },
        "CONTENT": {
          "LABEL": "Μήνυμα",
          "PLACEHOLDER": "Please write the message you want to save as a template to use later.",
          "ERROR": "Το μήνυμα είναι απαραίτητο."
        },
        "ATTACHMENTS": {
          "LABEL": "Συνημμένα"
        },
        "INBOXES": {
          "LABEL": "Εισερχόμενα",
          "PLACEHOLDER": "Επιλέξτε εισερχόμενα (προαιρετικό, αφήστε κενό για όλα τα εισερχόμενα)"
        },
        "SUBMIT": "Καταχώρηση"
      },
      "BUTTON_TEXT": "Επεξεργασία",
      "API": {
        "SUCCESS_MESSAGE": "Canned response is updated successfully.",
        "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Διαγραφή",
      "API": {
        "SUCCESS_MESSAGE": "Canned response deleted successfully.",
        "ERROR_MESSAGE": "Αδυναμία σύνδεσης με τον Woot Server, Παρακαλώ προσπαθήστε αργότερα"
      },
      "CONFIRM": {
        "TITLE": "Επιβεβαίωση Διαγραφής",
        "MESSAGE": "Είσαστε σίγουροι για την διαγραφή ",
        "YES": "Yes, delete ",
        "NO": "No, keep "
      }
    }
  }
}
